import React from "react";

interface LongLeftArrowProps {
  size?: number;
  color?: string;
  title?: string;
  className?: string;
  [key: string]: any;
}

const LongLeftArrow: React.FC<LongLeftArrowProps> = ({
  size = 24,
  color = "#5C6670",
  title,
  className,
  ...props
}) => {
  const ariaProps = title
    ? { role: "img" as const, "aria-label": title }
    : { "aria-hidden": true };

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...ariaProps}
      {...props}
    >
      {title ? <title>{title}</title> : null}
      {/* Horizontal line */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7915 10.4998C17.7915 10.1546 17.5117 9.87482 17.1665 9.87482L4.6665 9.87482C4.32132 9.87482 4.0415 10.1546 4.0415 10.4998C4.0415 10.845 4.32132 11.1248 4.6665 11.1248L17.1665 11.1248C17.5117 11.1248 17.7915 10.845 17.7915 10.4998Z"
        fill={color}
      />
      {/* Arrow head */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.4419 5.89131C8.1979 5.64723 7.8021 5.64723 7.5581 5.89131L3.9806 9.46872C3.9739 9.47545 3.9671 9.48222 3.9603 9.48901C3.8394 9.60983 3.7087 9.74047 3.6132 9.86562C3.5013 10.0122 3.3809 10.222 3.3809 10.4999C3.3809 10.7778 3.5013 10.9876 3.6132 11.1342C3.7087 11.2594 3.8394 11.39 3.9603 11.5108C3.9671 11.5176 3.9739 11.5244 3.9806 11.5311L7.5581 15.1085C7.8021 15.3526 8.1979 15.3526 8.4419 15.1085C8.686 14.8644 8.686 14.4687 8.4419 14.2246L4.8645 10.6472C4.8061 10.5889 4.7588 10.5415 4.7186 10.4999C4.7588 10.4583 4.8061 10.411 4.8645 10.3526L8.4419 6.77519C8.686 6.53112 8.686 6.13539 8.4419 5.89131Z"
        fill={color}
      />
    </svg>
  );
};

export default LongLeftArrow;
